import _ from "lodash";
import { queryDic } from "@/api/BSC";
import store from "@/store/index.js";
/**
 * 获取字典及转码通用方法
 * @param arr {Array} 字典配置
 * @param obj {Object} 转码对象,可以是数组或对象
 */
export const fetchDics = async function(dicConfig, obj) {
  if (_.isEmpty(dicConfig)) {
    return;
  }

  let dicIds = [];
  for (let i = 0; i < dicConfig.length; i++) {
    if (dicConfig[i].force) {
      dicIds.push(dicConfig[i].id);
    } else if (!store.state.dicMap.has(dicConfig[i].id)) {
      dicIds.push(dicConfig[i].id);
    }
  }

  let dics = await queryDic(dicIds);
  for (let i in dics) {
    store.commit("mapDicData", dics[i]);
  }

  if (obj) {
    dicFormatter(dicConfig, obj);
  }

  return dics;
};

/**
 * 获取单一字典方法
 * @param  dicId 字典ID
 * @param  force 是否强制刷新
 */
export const getDic = async function(dicId, force) {
  if (!store.state.dicMap.has(dicId)) {
    let o = {};
    o.id = dicId;
    o.force = force;
    await fetchDics([o]);
  }
  return store.state.dicMap.get(dicId);
};

/**
 * 转码通用方法
 * @param arr {Array} 字典配置
 * @param obj {Object} 转码对象,可以是数组或对象
 * @param isReverse {Boolean} 是否反转,默认fale
 */
export const dicFormatter = function(dicConfig, obj, isReverse) {
  if (obj instanceof Array) {
    for (let i = 0; i < obj.length; i++) {
      objFormatter(obj[i]);
    }
  } else if (obj instanceof Object) {
    objFormatter(obj);
  }

  function objFormatter(o) {
    dicConfig.forEach(element => {
      if (o.hasOwnProperty(element.property)) {
        let items = store.state.dicMap.get(element.id) || [];
        items.forEach(function(value) {
          if (isReverse) {
            if (o[element.property] == value.dicItemName) {
              o[element.property] = value.dicItemCode + "";
            }
          } else {
            if (o[element.property] == value.dicItemCode) {
              o[element.property] = value.dicItemName;
            }
          }
        });
      }
    });
  }
};
